module.exports = __webpack_public_path__ + "static/media/5.5 Inch IPhone 6s_2.c6773d0f.png";